<h4 *ngIf="!edit">Create new partner group</h4>
<h4 *ngIf="edit">Edit partner group /{{item.name}}/{{item.id}}/</h4>
<form (ngSubmit)="save()" #itemForm="ngForm">
    <div class="item-panel partner-group-panel">
        <div class="p-grid">
            <div class="p-fluid p-md-6">
                <div class="p-field">
                    <label for="name">Nom *</label>
                    <input type="text" size="30" pInputText name="name" id="name" pattern="[\D]{3,50}" 
                           [required]="true" maxlength="50" minlength="3" autocomplete="off" [(ngModel)]="item.name"> 

                    <p-message severity="error" 
                               [text]="itemForm.controls['name'].errors['required'] ? 'name is required' : itemForm.controls['name'].errors['maxlength'] ? 'Must be smaller than 150 characters' : ''"
                               *ngIf="!itemForm.controls['name']?.valid&&itemForm.controls['name']?.dirty"></p-message>
                </div>
                <div class="p-field">
                    <label for="float-input">Description *</label>
                    <textarea size="30" pInputTextarea name="description"
                              [required]="true" maxlength="1000" autocomplete="off" [(ngModel)]="item.description"></textarea> 

                    <p-message severity="error" 
                               [text]="itemForm.controls['description'].errors['required'] ? 'description is required' : itemForm.controls['description'].errors['maxlength'] ? 'Must be smaller than 1000 characters' : ''"
                               *ngIf="!itemForm.controls['description']?.valid&&itemForm.controls['description']?.dirty"></p-message>
                </div>
                <div class="p-field">
                    <p-checkbox name="active" label="Active" class="p-mt-5" [(ngModel)]="item.active" binary="true"></p-checkbox>
                </div>
            </div>
            <div *ngIf="item.id >0" class="p-fluid p-md-6 p-field">
                <label>Formulaires</label>
                <div class="p-col p-col-fixed">
                    <p-tag *ngFor="let pg of item.formIds" styleClass="p-mr-2 p-mb-1" [value]="pg.name"></p-tag>
                </div>
                <label>Partenaires</label>
                <div class="p-col p-col-fixed">
                    <p-tag *ngFor="let pg of item.partnerIds" styleClass="p-mr-2 p-mb-1" [value]="pg.name"></p-tag>
                </div>
            </div>
        </div>
        <div class="ui-g">
            <div class="ui-g-4">
                <button pButton [disabled]="!itemForm.valid" type="submit" label="Validate" icon="pi pi-check" iconPos="left" style="margin-right: 0.5em;" class="ui-button-success"></button>
                <button pButton routerLink="/backendadmin/partner-groups"  type="button" label="Cancel"  icon="pi pi-times" iconPos="left" style="margin-right: 0.5em;" class="ui-button-danger"></button>
            </div>
        </div>
    </div>
</form>

